import { required, optional } from 'AppReact/schema';

export const hiddenInspectionTemplate = {
  active: required('boolean'),
  can_assign_admin: required('boolean'),
  can_assign_resident: required('boolean'),
  can_assign_tech: required('boolean'),
  icon: optional('string'),
  id: required('integer'),
  is_hidden: required('boolean'),
  name: required('string'),
};